// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__Pu01B","title":"styles_title__IwoCM","list":"styles_list__Ea64j"};
module.exports.__checksum = "b27309596ae0"